import React from "react";
import { Div } from "@components/Generics.react";
import "@styles/components.scss";

export default function LiquidProgressChart(props) {
    const {
        id,
        width = 250,
        height = 250,
        color = "#121212",
        noText = false,
        value,
        subText,
        inverted = false,
    } = props;

    const bottomOffset = -width + (width * 0.7 * value) / 100;
    const liquidColorReg =
        value < 30 ? "#FF6B6B" : value < 70 ? "#EEAE5E" : "#7ec583";
    const liquidColorInv =
        value < 30 ? "#7ec583" : value < 70 ? "#EEAE5E" : "#FF6B6B";
    const liquidColor = inverted ? liquidColorInv : liquidColorReg;
    // Generate dynamic CSS for the liquid level.
    // Adjust the bottom property to control the height of the liquid.
    const dynamicLiquidStyle = `
    .liquid-progress.${id} .potion-body .potion-content::after {
      bottom: ${bottomOffset}px;
      background-color: ${liquidColor};
    }
  `;

    return (
        <Div relative wd={`${width}px`} ht={`${height}px`} centered>
            <div className={`liquid-progress ${id}`}>
                <style>{dynamicLiquidStyle}</style>
                <div className="potion-body">
                    <div className="potion-content"></div>
                </div>
            </div>
            {!noText && (
                <Div
                    absolute
                    className="liquid-progress-text"
                    style={{ color: color }}
                >
                    <Div large bold spaceBottom={subText != null}>
                        {parseInt(value, 0)}
                        <Div tiny inline>
                            %
                        </Div>
                    </Div>
                    {subText && (
                        <Div tiny center-align style={{ marginTop: "-10px" }}>
                            {subText}
                        </Div>
                    )}
                </Div>
            )}
        </Div>
    );
}

// Data Format
// -------------------------------
/*
    <LiquidProgressChart
        value={60}
        width={40}
        height={40}
        color={"#ffbf00"}
        noText
    />;
*/
